module.exports = __webpack_public_path__ + "img/text_m.a554a9c1.png";